"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientContactType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PatientContactType_Factory = /** @class */ (function () {
    function PatientContactType_Factory() {
    }
    PatientContactType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            Id: model.Id,
        };
        return result;
    };
    PatientContactType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            Id: model.Id,
        };
        return result;
    };
    return PatientContactType_Factory;
}());
exports.PatientContactType_Factory = PatientContactType_Factory;
